import React, { useEffect, useState } from 'react'
import {
  Backdrop,
  Box, Button,
  Card, Chip,
  Container, Dialog, DialogContent, Divider,
  Grid, InputAdornment, Menu, Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, TextField,
  Typography,
} from '@mui/material'
import { api } from '../../../services/Main/Api'
import moment from 'moment'
import { Helmet } from 'react-helmet'
import CircularProgress from '@mui/material/CircularProgress'

import NoResultsAnimation from '../../../components/Shared/animations/NoResultsAnimation'
import {
  ArticleOutlined,
  CurrencyExchange,
  LocalAtmOutlined,
  ReceiptOutlined,
  Search
} from '@mui/icons-material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Masks from '../../../components/Shared/Masks'
import PaginationGlobal from "../../../components/Shared/PaginationGlobal";
import {getCondoId} from "../../../services/Main/AuthStorage";
import { styled } from '@mui/system'
import {CalendarIcon, DesktopDatePicker} from "@mui/x-date-pickers";
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {DateRangePicker} from "react-date-range";
import {endOfMonth, endOfYear, startOfMonth, startOfYear, subDays, subMonths} from "date-fns";


const RentReportList = () => {
  const navigate = useNavigate()
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState(null)
  const [personName, setPersonName] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();



  const [filters, setFilters] = useState(
      {
        unit__condo_id: getCondoId(),
        search:'',
        page: 1,
        page_size: 50,
      }
  )


  const monthFormat = moment().format("MM")
  const yearFormat = moment().format("YYYY")
  const [dataRange, setDateRange] = useState([
    {
      startDate: startOfMonth(new Date()),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)


  function getData(){
    setLoading(true)
    const {page, page_size, ...otherFilters} = filters;

    let filter = {...otherFilters, page, page_size}

    if (searchParams.get("rent_contract_id")){
      filter = {...filter, rent_contract_id: searchParams.get("rent_contract_id")}
    }

    if (searchParams.get("invoice_id")){
      filter = {...filter, invoice_id: searchParams.get("invoice_id")}
    }

    if (searchParams.get("search")){
      filter = {...filter, search: searchParams.get("search")}
    }

    if (searchParams.get("startDate") && searchParams.get("endDate")){
      filter = {...filter, start_date: searchParams.get("startDate"), end_date: searchParams.get("endDate")}
    }

    api.get(`finance-invoice/`, {params: filter})
      .then(response => {
        const data = response.data
        setResponse(data)
        setLoading(false)
        window.scrollTo(0, 0)
      }).catch(error => {
        console.log(error)
        setLoading(false)
    })
  }

  const downloadCSV = async () => {
    setLoading(true)
    let month = monthFormat
    let year = yearFormat

    if (searchParams.get("month") && searchParams.get("year") ){
      month = searchParams.get("month")
      year = searchParams.get("year")
    }

    const {page, page_size, ...otherFilters} = filters;

    let filter = {...otherFilters, month:month, year:year}

    if (searchParams.get("rent_contract_id")){
      filter = {...filter, rent_contract_id: searchParams.get("rent_contract_id")}
    }

    if (searchParams.get("invoice_id")){
      filter = {...filter, invoice_id: searchParams.get("invoice_id")}
    }

    if (searchParams.get("search")){
      filter = {...filter, search: searchParams.get("search")}
    }

    if (searchParams.get("startDate") && searchParams.get("endDate")){
      filter = {...filter, start_date: searchParams.get("startDate"), end_date: searchParams.get("endDate")}
    }

    try {
      const response = await api.get('finance-invoice/download/', {params: filter, responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        }, });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const contentHeader = response.headers['content-type'];
      const filename = contentHeader.split('name=')[1];
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      setLoading(false)
    } catch (err) {
      console.log(err);
      setLoading(false)
    }
  };

  let typingTimer  = ""

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  }));

// Funções de intervalos separadas
  const getCurrentMonthRange = () => ({
    startDate: startOfMonth(new Date()),  // Início do mês atual
    endDate: endOfMonth(new Date()),      // Fim do mês atual
  });

  const getLastMonthRange = () => ({
    startDate: startOfMonth(subMonths(new Date(), 1)),  // Início do último mês
    endDate: endOfMonth(subMonths(new Date(), 1)),      // Fim do último mês
  });

  const getLast30DaysRange = () => ({
    startDate: subDays(new Date(), 30),  // Últimos 30 dias
    endDate: new Date(),
  });

  const getLast3MonthsRange = () => ({
    startDate: subMonths(new Date(), 3),  // Últimos 3 meses
    endDate: new Date(),
  });

  const getLast6MonthsRange = () => ({
    startDate: subMonths(new Date(), 6),  // Últimos 6 meses
    endDate: new Date(),
  });

  const getLast12MonthsRange = () => ({
    startDate: subMonths(new Date(), 12), // Últimos 12 meses
    endDate: new Date(),
  });

  const getCurrentYearRange = () => ({
    startDate: startOfYear(new Date()),  // Início do ano
    endDate: endOfYear(new Date()),      // Fim do ano
  });

  const customStaticRanges = [
    {
      label: 'Mês atual',
      range: getCurrentMonthRange, // Referência à função
      isSelected(range) {
        return range.startDate === startOfMonth(new Date()) && range.endDate === endOfMonth(new Date());
      },
    },
    {
      label: 'Último mês',
      range: getLastMonthRange, // Referência à função
      isSelected(range) {
        const lastMonthStart = startOfMonth(subMonths(new Date(), 1));
        const lastMonthEnd = endOfMonth(subMonths(new Date(), 1));
        return range.startDate === lastMonthStart && range.endDate === lastMonthEnd;
      },
    },
    {
      label: 'Últimos 30 dias',
      range: getLast30DaysRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastThirtyDays = subDays(now, 30);
        return range.startDate === lastThirtyDays && range.endDate === now;
      },
    },
    {
      label: 'Últimos 3 meses',
      range: getLast3MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastThreeMonths = subMonths(now, 3);
        return range.startDate === lastThreeMonths && range.endDate === now;
      },
    },
    {
      label: 'Últimos 6 meses',
      range: getLast6MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastSixMonths = subMonths(now, 6);
        return range.startDate === lastSixMonths && range.endDate === now;
      },
    },
    {
      label: 'Últimos 12 meses',
      range: getLast12MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastYear = subMonths(now, 12);
        return range.startDate === lastYear && range.endDate === now;
      },
    },
    {
      label: 'Neste ano',
      range: getCurrentYearRange, // Referência à função
      isSelected(range) {
        return range.startDate === startOfYear(new Date()) && range.endDate === endOfYear(new Date());
      },
    },
  ];


  const handleClose = () => {
    setOpen(false);
  };
  const [open, setOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };


  useEffect(()=>{
    let params = { ...searchParams, search, "startDate": startDate, "endDate": endDate,}
    if (search){
      params.search = search
    }else{
      delete params.search
    }

    setSearchParams(params)
  }, [search])


  useEffect(()=>{

    setStartDate(moment(dataRange[0].startDate).format("YYYY-MM-DD"))
    setEndDate(moment(dataRange[0].endDate).format("YYYY-MM-DD"))
  }, [dataRange])

  useEffect(()=>{

    let params = { ...searchParams, "startDate": moment(dataRange[0].startDate).format("YYYY-MM-DD"), "endDate": moment(dataRange[0].endDate).format("YYYY-MM-DD"), }
    if (search){
      params.search = search
    }else {
      delete params.search
    }

    setSearchParams(params)
  }, [startDate, endDate])

  useEffect(() => {

    if (searchParams.get("startDate") && searchParams.get("endDate")){
      getData()
    }
  }, [searchParams])

  useEffect(() => {

    if (searchParams.get("startDate") && searchParams.get("endDate")){
      getData()
    }

  }, [filters])
  return (
    <>
      <Helmet>
        <title>Relatório Geral - Bloco B3</title>
      </Helmet>

      <Backdrop
        sx={{ color: '#fff', zIndex: 1500, }}
        open={loading}
      >

        <CircularProgress color="inherit"/>
      </Backdrop>
      <Container maxWidth={false}>
        <Box
          sx={{
            display: 'flex',
            '@media (max-width:600px)': {
              display: 'grid',
              gridTemplateColumns: 'repeat(1, 1fr)',
              gap: 3,
            },
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,

          }}
        >
          <Typography
            textAlign={'center'}
            variant={'h5'}
          >
            Relatório Geral
          </Typography>
          <Box  sx={{textAlign: "right"}}>
            <TextField id="outlined-basic" label="Buscar" variant="outlined" sx={{marginRight: ".5rem"}}
            onKeyUp={(event)=>{
              clearTimeout(typingTimer);
              typingTimer = setTimeout(()=> {
                // setFilters({...filters, page: 1})
                setSearch(event.target.value)
              }, 1000);

            }}
            size={'small'}
           InputProps={{
             endAdornment: <InputAdornment position="end"><Search/></InputAdornment>,
           }}
            />
            <Button
                id="basic-button"
                startIcon={<CalendarIcon />}
                aria-controls={openMenu ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={handleClick}
                variant={"outlined"}
            >
              {moment(startDate, "YYYY-MM-DD").format("DD MMM YYYY")} - {moment(endDate, "YYYY-MM-DD").format("DD MMM YYYY")}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                sx={{minWidth:"200px"}}
            >
              <MenuItem onClick={()=>{
                const range = getCurrentMonthRange()

                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Mês Atual</MenuItem>
              <Divider/>
              <MenuItem onClick={()=>{
                const range = getLastMonthRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Último Mês</MenuItem>
              <Divider/>
              <MenuItem  onClick={()=>{
                const range = getLast30DaysRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Últimos 30 dias</MenuItem>
              <Divider/>
              <MenuItem onClick={()=>{
                const range = getLast3MonthsRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}} >Últimos 3 meses</MenuItem>
              <Divider/>
              <MenuItem onClick={()=>{
                const range = getLast6MonthsRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Últimos 6 meses</MenuItem>
              <Divider/>
              <MenuItem onClick={()=>{
                const range = getLast12MonthsRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Últimos 12 meses</MenuItem>
              <Divider/>
              <MenuItem onClick={()=>{
                const range = getCurrentYearRange()
                setDateRange([{
                  startDate: range.startDate,
                  endDate: range.endDate,
                  key: 'selection'
                }])
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Neste Ano</MenuItem>
              <Divider/>
              <MenuItem onClick={()=> {
                setOpen(true)
                handleCloseMenu()
              }} sx={{ fontSize:".8rem"}}>Customizar</MenuItem>

            </Menu>




            <Dialog
                open={open}
                maxWidth="md"
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

              <DialogContent>
                <DateRangePicker
                    onChange={item => setDateRange([item.selection])}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={2}
                    ranges={dataRange}
                    direction="horizontal"
                    preventSnapRefocus={true}
                    calendarFocus="backwards"
                    staticRanges={[...customStaticRanges]} // Adiciona as opções customizadas às padrão
                />

              </DialogContent>

            </Dialog>
          </Box>
        </Box>

        <Grid container spacing={2} justifyContent={"space-between"}>
          <Grid item xs={12} md={4} lg={4} xl={2}>
            <Item >
              <ArticleOutlined sx={{ color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36', marginBottom: "1rem" }}>Alugueis</Typography>

              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                  <Skeleton variant="rectangular" width={200} height={50} />
                  :
                  <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }} >
                    {response?.rent_contract && Masks.money(response?.rent_contract.toString())}
                  </Typography>
                }

              </Box>
            </Item>
          </Grid>
          <Grid item xs={12} md={4} llg={4} xl={2}>
            <Item >
              <ReceiptOutlined sx={{color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36', marginBottom: "1rem" }}> Faturas</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                  <Skeleton variant="rectangular" width={200} height={50} />
                  :
                  <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }}>
                    {response?.invoice && Masks.money(response?.invoice.toString())}
                  </Typography>
                }

              </Box>
            </Item>
          </Grid>
          <Grid item xs={12} md={4} lg={4} xl={2}>
            <Item >
              <LocalAtmOutlined sx={{ color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}> Repasses</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                  <Skeleton variant="rectangular" width={200} height={50} />
                  :
                  <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }} >
                    {response?.transfer && Masks.money(response?.transfer.toString())}
                  </Typography>
                }
              </Box>
            </Item>
          </Grid>
          <Grid item xs={12} md={4} lg={4} xl={2}>
            <Item >
              <CurrencyExchange sx={{ color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}> Taxa Administrativa</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                  <Skeleton variant="rectangular" width={200} height={50} />
                  :
                  <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }} >
                    {response?.administration_fee && Masks.money(response?.administration_fee.toString())}
                  </Typography>
                }
              </Box>
            </Item>
          </Grid>
          <Grid item xs={12} md={4} lg={4} xl={2}>
            <Item >
              <CurrencyExchange sx={{ color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}> Intermediação</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }} >
                      {response?.intermediation_fee && Masks.money(response?.intermediation_fee.toString())}
                    </Typography>
                }
              </Box>
            </Item>
          </Grid>
          <Grid item xs={12} md={4} lg={4} xl={2}>
            <Item >
              <CurrencyExchange sx={{ color:'primary.main', flexGrow:1  }} />
              <Box>
                <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}> IPTU</Typography>
              </Box>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                { loading ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.5rem" }} >
                      {response?.iptu_fee && Masks.money(response?.iptu_fee.toString())}
                    </Typography>
                }
              </Box>
            </Item>
          </Grid>
        </Grid>
        <Card sx={{mt:5}}>
          {response?.results ?
            <>

              <Grid container sx={{ p: 2, alignItems: 'center' }} spacing={1}>
                <Grid item xs={12} sm={4} lg={3}>
                </Grid>

              </Grid>
              <Box display={'flex'} justifyContent={'space-between'} marginX={'1rem'}>
                <Box>

                </Box>

                  <Button variant="outlined" size={'small'} onClick={downloadCSV}>
                    <SystemUpdateAltIcon
                        style={{ fontSize: 20, marginRight: '10px' }}
                        color="primary"
                    />
                    Exportar
                </Button>
              </Box>

              <TableContainer sx={{ maxHeight: 1024,}}>
                {response?.results?.length > 0  ?
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{fontSize: 12}}>Locatário</TableCell>
                        <TableCell sx={{fontSize: 12}}>Beneficiários</TableCell>
                        <TableCell sx={{fontSize: 12}}>Fatura Paga em</TableCell>
                        <TableCell sx={{fontSize: 12}}  align={'center'}>Aluguel</TableCell>
                        <TableCell sx={{fontSize: 12}}  align={'center'}>Fatura</TableCell>
                        <TableCell sx={{fontSize: 12}} align={'center'}>Repasse</TableCell>
                        <TableCell sx={{fontSize: 12}} align={'center'}>Taxa Administrativa</TableCell>
                        <TableCell sx={{fontSize: 12}} align={'center'}>Intermediação</TableCell>
                        <TableCell sx={{fontSize: 12}} align={'center'}>IPTU</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>


                    { response.results.map(item =>
                      <TableRow
                        key={item.id}
                        hover
                        sx={{'cursor': 'pointer'}}
                      >
                        <TableCell onClick={(e) => {
                          e.stopPropagation()
                          navigate(`/contratos/${item.rent_contract_id}`)
                        }}>
                            {item.rent_contract}
                        </TableCell>
                        <TableCell>
                          {item.transfers}
                        </TableCell>
                        <TableCell>
                          {moment(item?.paid_at).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell align={'center'} onClick={(e) => {
                          e.stopPropagation()
                          navigate(`/contratos/${item.rent_contract_id}`)
                        }}>
                            {Masks.money(item?.total_rent_contract.toString())}
                        </TableCell>
                        <TableCell  align={'center'} onClick={(e) => {
                          e.stopPropagation()
                          navigate(`/faturas/${item.id}`)
                        }}>
                          {Masks.money(item?.total.toString())}
                        </TableCell>

                        <TableCell align={'center'} >
                          {item?.total_transfer > 0 ? Masks.money(item?.total_transfer.toString()) : <Chip size={"small"} label={"Não realizado"}/>}
                        </TableCell>

                        <TableCell align={'center'}>
                            {Masks.money(item?.administrative_fee.toString())}
                        </TableCell>
                        <TableCell align={'center'}>
                          {Masks.money(item?.intermediation_fee.toString())}
                        </TableCell>
                        <TableCell align={'center'}>
                          {Masks.money(item?.iptu_fee.toString())}
                        </TableCell>
                      </TableRow>
                    )}

                    </TableBody>
                  </Table>
                  :
                  <NoResultsAnimation />
                }
              </TableContainer>
            </>
            :
            <Skeleton
              variant="rounded"
              height={700}
              animation="pulse"
            />
          }
        </Card>

      </Container>
      {response?.count > 0 &&
        <PaginationGlobal
          state={response}
          filters={filters}
          setFilters={setFilters}
        />
      }
    </>
  )
}

export default RentReportList
